module.exports = __webpack_public_path__ + "8c80b6e27da70e09f2ca50af227fef31.svg";